export const SET_NEWSTAGS = "setNewstags";
